import { Utility } from '../_service/utility';
import { SafeResourcePipe } from '../_pipes/chineseCounter.pipe';
import { Injectable } from "@angular/core";

@Injectable()
export class SliderTransformer {
    constructor(private _utility:Utility)
    {
        
    }
    fromList(item) {
        const result = {
            title: item.title,
            image: this._utility.GetSafeResource(item.img.replace("dnvod.tv",this._utility.GetHost()).replace("http:","https:")),
            background: item.att,
            videoId: item.url.split('=')[1],
            externallink: item.id === -1 ? item.url : undefined,
        };
        return result;
    }
}
